<template>
  <div class="flex flex-col gap-6 big-desktop:grid big-desktop:grid-cols-2">
    <slot></slot>
  </div>
</template>
